import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { identity } from '../../chronicles-ui/identity';
import { SidebarView } from '../../chronicles-ui/sidebar/SidebarView';
import './Sidebar.css';

function RouterLink({ to, kind, activePath, children, ...props }) {
    if (kind === 'app') return <NavLink to={to} {...props}>{children}</NavLink>;
    // Wiki links leave the SPA, including ordinary and modified clicks.
    return <a href={to} {...props}>{children}</a>;
}

export default function Sidebar({ staffPermissions, token, characterName, firstName, onLogout, showWikiLinks = process.env.REACT_APP_WIKI_LINKS_ENABLED === 'true' }) {
    const navigate = useNavigate();
    return <SidebarView
        Link={RouterLink}
        staffPermissions={staffPermissions}
        showWikiLinks={showWikiLinks}
        signedIn={Boolean(token)}
        characterName={characterName}
        firstName={firstName}
        onLogin={() => identity.login()}
        onLogout={() => { onLogout(); navigate('/login'); }}
    />;
}
